/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-redundant-roles */

import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import "../css/checkout.css";
import "../css/checkout-modify.css";
import Collapse from "../components/Collapse";
import OrderSummary from "../components/Collapse/OrderSummary";
import Loading from "../components/Loading";
import writeCookie from "../function/writeCookie";
import getCookie from "../function/getCookie";
import i18n from "i18next";
import { Translation } from "react-i18next";
import { Helmet } from "react-helmet";
import isUrlEn from "../function/isUrlEn";

//models
import {
  addresses,
  customer,
  login,
  loginPopup,
  countryList,
  myBag,
  loading,
  pickUpInStore,
  mobileMenu,
  myFav,
  coupon
} from "../models";
import ErrorPage from "../components/ErrorPage";
import { PAYPAL_CLIENT_ID } from "../constants";
import urlReplace from "../function/replaceUrl";
import Coupon from "../components/Coupon";
import CouponMobile from "../components/CouponMobile";
import CouponWarning from "../components/CouponWarning";
import { setGAEvent } from "../function/setGAEvent";

class Checkout extends React.Component {
  state = {
    lang: "zhTW",
    addresses: [],
    syleStatus: true
  };

  async componentDidMount() {
    const {
      fetchUser,
      showLoginPopup,
      fetchCountryList,
      fetchMenuCountryList,
      showMobileMenu,
      fetchMyFavList
    } = this.props;
    const isCheckoutPage = true;
    const url = window.location.pathname;

    /*先抓URL判斷語系*/
    isUrlEn(url);
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }

    window.addEventListener("message", function (event) {
      if (event.data === "emphasisSuccess") {
        showLoginPopup(false); //登入成功後便關閉Popup畫面
        showMobileMenu(false); //登入成功後便關閉手機板Menu畫面
        fetchUser(isCheckoutPage);
      }
      return;
    });

    fetchCountryList();
    fetchMenuCountryList();
    fetchUser(isCheckoutPage);

    window.addEventListener("message", e => {
      if (e.data === "HEADER_UPDATE_WISHLIST") {
        fetchMyFavList();
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.myBagData !== this.props.myBagData) {
      if (this.state.syleStatus) {
        if (window.dataLayer) {
          const cartItems = this.props.myBagData.cartItems;
          const products = [];
          if (Array.isArray(cartItems)) {
            cartItems.forEach(item => {
              const obj = {};
              obj.brand = item.information.prodname1;
              obj.name = item.information.prodname2;
              obj.id = item.information.code;
              obj.price = Number(
                item.discountAmount.replace(/^HK\$/, "").replace(/,/g, "")
              );
              obj.quantity = item.quantity;
              products.push(obj);
            });
          }
          window.dataLayer.push({
            event: "checkout",
            ecommerce: {
              checkout: {
                actionField: { step: 1 },
                products: products
              }
            }
          });
        }

        setGAEvent("view_cart", this.props.myBagData);

        this.setState({ syleStatus: false });
      }
    }
  }

  async handleClickLang(event) {
    const {
      fetchCountryList,
      fetchMyBag,
      fetchCountryIncludeHK,
      fetchInStore,
      fetchDutyTax,
      fetchMenuCountryList,
      startLoading
    } = this.props;

    if (event.target.value === "en") {
      i18n.changeLanguage("en");
      writeCookie("eshop-hk-language", "en");
      this.setState({
        lang: "en"
      });
      /*塞en回url字串*/
      urlReplace(window.location.pathname, "tc", "en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      writeCookie("eshop-hk-language", "zh_HK"); //香港網站
      this.setState({
        lang: "zhTW"
      });
      /*塞tc回url字串*/
      urlReplace(window.location.pathname, "en", "tc");
    }

    startLoading(true);
    try {
      await fetchMyBag(); // 切換語系，再次取得myBag資料
    } finally {
      startLoading(false);
    }
    fetchCountryList(); // 切換語系，取得英文國家列表
    fetchMenuCountryList();
    fetchCountryIncludeHK(); // 切換語系，取得含有香港的國家清單
    fetchInStore(); // 切換語系，取得含有分行資料

    // 切換語系，再次發送 delivery，取得該語言的文字說明
    const countryCode = getCookie("countryCode");
    if (countryCode) {
      fetchDutyTax(countryCode);
    }
  }

  render() {
    const { isLoading, errorPage, myBagData } = this.props;
    const { lang } = this.state;
    const description =
      lang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <>
        {errorPage ? (
          <>
            {/* 如果fetchMyBag() Status 500 失敗，則顯示ErrorPage */}
            <ErrorPage />
          </>
        ) : (
          <>
            <Helmet>
              <title>EMPHASIS</title>
              <meta name="description" content={description} />
              <link rel="canonical" href={window.location.href} />
              <script
                src={`https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=HKD`}
              ></script>
            </Helmet>
            <div id="header"></div>
            {isLoading && <Loading />}
            <div className="pageContent_wrap">
              <div className="content-wrapper-wider" id="sticky-top">
                {/* <div className="breadcrumb_wrap d-none d-md-block">
              <a className="breadcrumb__link" href="#">
                <span>首頁</span>
              </a>
              <a className="breadcrumb__link" href="#">
                <span>我的購物袋</span>
              </a>
            </div> */}

                <Translation>
                  {t => (
                    <p className="pageBigTitle" id="checkout-title">
                      {t(`checkout.checkout`)}
                    </p>
                  )}
                </Translation>

                <div className="row no-gutters parent_forSticky">
                  <div
                    className="col-12 col-md-7 left_wrap"
                    id="checkout-left-wrap"
                  >
                    <Collapse
                      lang={this.state.lang}
                      // addresses={(addresses && addresses) || {}}
                      // customer={customer}
                      // isLogin={isLogin}
                    />
                  </div>

                  <div className="col-1 d-none d-md-block"></div>

                  <div
                    className="col-4 checkout-right_wrap d-none d-md-block sidebar_forSticky"
                    id="order-sticky-content"
                  >
                    <div
                      className="content sidebarInner_forSticky"
                      id="order-sticky"
                    >
                      <OrderSummary />
                      <Coupon />
                      <Translation>
                        {t => (
                          <p className="help">
                            {t("checkout.needHelp")}
                            <a href="tel:+852 2192 3228"> +852 2192 3228</a>
                          </p>
                        )}
                      </Translation>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CouponMobile />
            <CouponWarning
              title={
                <Translation>
                  {t => <>{t("checkout.couponPopTitle")}</>}
                </Translation>
              }
              body={
                <div style={{ fontSize: "14px" }}>
                  {this.props.couponPopText}
                </div>
              }
              active={this.props.couponWarning}
              submitEvent={() => {
                this.props.showCouponWarning(false);
              }}
              cancelEvent={() => {
                var couponCode =
                  myBagData.coupons.length > 0
                    ? myBagData.coupons[0].couponCode
                    : "";
                this.props.deleteCouponCode(couponCode);
                this.props.showCouponWarning(false);
              }}
            />
            <footer id="footer"></footer>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    isLoading: state.loading.isLoading,
    countryCode: state.countryList.countryCode,
    errorPage: state.errorPage.errorPage,
    couponWarning: state.coupon.couponWarning,
    couponPopText: state.coupon.couponPopText,
    myBagData: state.myBag.myBagData,
    isLogin: state.login.signed
  };
};
const mapDispatchToProps = () => {
  return {
    fetchMenuCountryList: () => countryList.actions.fetchMenuCountryList(),
    fetchAddresses: () => addresses.actions.fetchAddresses(),
    fetchCustomer: () => customer.actions.fetchCustomer(),
    fetchUser: isCheckoutPage => login.actions.fetchUser(isCheckoutPage),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchInStore: () => pickUpInStore.actions.fetchInStore(),
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode),
    fetchMyBag: () => myBag.actions.fetchMyBag(),
    startLoading: bool => loading.actions.startLoading(bool),
    fetchCountryIncludeHK: () => countryList.actions.fetchCountryIncludeHK(),
    showMobileMenu: bool => mobileMenu.actions.showMobileMenu(bool),
    updateMyFav: (data, bool) => myFav.actions.updateMyFav(data, bool),
    fetchMyFavList: () => myFav.actions.fetchMyFavList(),
    showCouponWarning: bool => coupon.actions.showCouponWarning(bool),
    deleteCouponCode: code => coupon.actions.deleteCouponCode(code)
  };
};

const withRouterCheckout = withRouter(Checkout);
export default connect(mapStateToProps, mapDispatchToProps)(withRouterCheckout);
